module.exports = __webpack_public_path__ + "assets/images/e6625f45a5241ae27fb1bf3786a8c801.png";